import { LenderConcession } from '../../interfaces';

export const ComenityBank: LenderConcession = {
  lenderNameRegEx: new RegExp('^CB/|CBSD|CBGAFS|CBSBANK|CB INDIGO|CBW/'),
  standardMinimumPercent: 3.0,
  minimumDollarAmount: 15,
  apr: 10.0,
};
